import { captureException } from '@/errors'
import { handleApiError } from './enhancedErrorHandler'

export default async function handleError(error, context = {}) {
  // Log para debugging
  console.error('Error handled:', error)

  // Captura exceção para análise
  captureException(error)

  // Casos especiais de redirecionamento
  if (error && error.status && error.status === 401 && !error.skipRedirect) {
    try {
      const { default: router } = await import('@/router')
      router.push({
        name: 'logout',
        params: {}
      })
    } catch (importError) {
      console.error('Erro ao importar router:', importError)
      window.location.href = '/logout'
    }
    return
  }

  // Delega para o novo sistema de tratamento de erro
  await handleApiError(error, context)
}
